<script setup lang="ts">
import { computed } from 'vue';

import logoDarkTheme from '@satellite/../public/images/opendock_logo_dark_theme.svg';
import logoLightTheme from '@satellite/../public/images/opendock_logo_light_theme.svg';

const {
  logoPath = null,
  lightMode = false,
  width,
  height
} = defineProps<{
  logoPath?: string | null;
  lightMode?: boolean;
  width?: string | number;
  height?: string | number;
}>();

const computedLogoPath = computed(() => logoPath ?? (lightMode ? logoLightTheme : logoDarkTheme));
</script>

<template>
  <div>
    <img :src="computedLogoPath" :width="width" :height="height" alt="Opendock" />
  </div>
</template>
